import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import {
  Box,
  Button,
  Grid,
  Toolbar,
  Typography,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  Slide,
  Modal,
  Paper,
  Alert,
  Badge,
  Divider,
  Stack,
  Tooltip
} from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  InputBase,
} from "@mui/material";
//import CreateGroup from './CreateGroup'
import Key from "../../clientVariables.json";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../user-redux/selector";
import axios from "axios";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EmailIcon from "@mui/icons-material/Email";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from '@mui/icons-material/Download';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import { DataGrid } from "@mui/x-data-grid";
import { appSelector } from "../redux/selector";
import "../../App.css";
import Mailer from "./Mailer";
import { getActiveCandidatesAction, resetCandidatesAction } from "../redux/action";
import { keyframes } from "@mui/system";
import { validateReoonEmailVerification } from "../../helpers/EmailFieldValidator";
import moment from "moment";

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const modalStyles = {
  width: "90%",
  maxWidth: "1200px",
  bgcolor: "background.paper",
  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
  p: 0,
  borderRadius: "12px",
  maxHeight: "85vh",
  overflowY: "auto",
  outline: 'none',
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

function Groups() {
  const [open, setOpen] = useState(false);
  const [viewMode, setViewMode] = useState("grid");
  const [mailOpen, setMailopen] = useState(false);
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [validEmails, setValidEmails] = useState([]);
  const [totalMails, setTotalMails] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { vmail_token } = useSelector(appSelector);
  const [groups, setGroups] = useState([]);
  const [nameError, setNameError] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [nameHelperText, setNameHelperText] = useState("");
  const [fileHelperText, setFileHelperText] = useState("");
  const [groupId, setGroupId] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  };
  const [columns, setColumns] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState([]);
  const [selectedFileEmails, setSelectedFileEmails] = useState([]);
  const [bulkTaskId, setBulkTaskId] = useState(null);
  const [bulkStatus, setBulkStatus] = useState(null);
  const [bulkResults, setBulkResults] = useState({});
  const [isVerifying, setIsVerifying] = useState(false);
  const [verificationProgress, setVerificationProgress] = useState(0);
  const [verifiedEmails, setVerifiedEmails] = useState([]);
  const [invalidEmails, setInvalidEmails] = useState([]);
  const [showInvalidEmails, setShowInvalidEmails] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editName, setEditName] = useState("");
  const [editEmails, setEditEmails] = useState([]);
  const [editGroupId, setEditGroupId] = useState("");
  const [emailEditingIndex, setEmailEditingIndex] = useState(null);
  const [emailEditingValue, setEmailEditingValue] = useState("");
  const [newEmailEntry, setNewEmailEntry] = useState("");
  const [editSearchTerm, setEditSearchTerm] = useState("");
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);
  //console.log("Redux appSelector:", useSelector(appSelector));

  const handleCardClick = (id) => {
    groups.forEach((item) => {
      if (item._id === id) {
        setSelectedGroup(item);
        const parsedEmails = item.emails.map((email, index) => ({
          id: index,
          Email: email,
        }));
        setSelectedFileEmails(parsedEmails);

        // Dynamically set columns based on the emails array structure
        const columnsData = Object.keys(parsedEmails[0] || {}).map((key) => ({
          key,
          name: key,
          resizable: true,
        }));
        setColumns(columnsData);

        setDetailModalOpen(true); // Open the modal
      }
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
    setRows([]);
    setColumns([]);
  };

  const handleClose = () => {
    setOpen(false);
    setFile(null);
    setName("");
    setFileError(false);
    setFileHelperText("");
    setNameError(false);
    setNameHelperText("");
    setSelectedFileData([]);
    setRows([]);
    setColumns([]);
    setValidEmails([]);
    setTotalMails(0);
    setBulkTaskId(null);
    setBulkStatus(null);
    setBulkResults({});
    setIsVerifying(false);
    setVerificationProgress(0);
    setVerifiedEmails([]);
    setInvalidEmails([]);
    setShowInvalidEmails(false);
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    // Always reset all validation states on new upload
    setFile(file);
    setFileError(false);
    setFileHelperText("");
    setValidEmails([]);
    setRows([]);
    setColumns([]);
    setSelectedFileData([]);
    setTotalMails(0);
    setBulkTaskId(null);
    setBulkStatus(null);
    setBulkResults({});
    setIsVerifying(false);
    setVerificationProgress(0);
    setVerifiedEmails([]);
    setInvalidEmails([]);
    setShowInvalidEmails(false);

    if (!file) {
      setFileError(true);
      setFileHelperText("File is required.");
      return;
    }

    if (file.type !== "text/csv") {
      setFileError(true);
      setFileHelperText("Only CSV files are allowed.");
      return;
    }

    Papa.parse(file, {
      header: false, // First try without headers
      skipEmptyLines: true,
      complete: function (results) {
        let data = results.data;
        let emails = [];

        // Case 1: Single column of emails (no header)
        if (data[0].length === 1) {
          emails = data.map(row => row[0].trim());
        }
        // Case 2: May have headers - try parsing with headers
        else {
          // Reparse with headers
          Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: function (headerResults) {
              processEmailData(headerResults.data);
            }
          });
          return;
        }

        processEmailData(emails);
      }
    });
  };

  const getReoonApiKey = () => Key.reoon_api_key;

  const startBulkVerification = async (emails) => {
    setIsVerifying(true);
    setBulkStatus("pending");
    setBulkResults({});
    setBulkTaskId(null);
    setVerificationProgress(0);
    setVerifiedEmails([]);
    setInvalidEmails([]);
    try {
      const res = await axios.post(
        "https://emailverifier.reoon.com/api/v1/create-bulk-verification-task/",
        {
          name: `Bulk Verification ${new Date().toISOString()}`,
          emails,
          key: getReoonApiKey(),
        }
      );
      if (res.data && res.data.status === "success") {
        setBulkTaskId(res.data.task_id);
        pollBulkVerification(res.data.task_id);
      } else {
        toast.error("Failed to start bulk verification");
        setIsVerifying(false);
      }
    } catch (err) {
      toast.error("Bulk verification API error");
      setIsVerifying(false);
    }
  };


  const pollBulkVerification = async (taskId) => {
    try {
      const url = `https://emailverifier.reoon.com/api/v1/get-result-bulk-verification-task/?key=${getReoonApiKey()}&task_id=${taskId}`;
      const res = await axios.get(url);
      if (res.data) {
        setBulkStatus(res.data.status);
        setVerificationProgress(res.data.progress_percentage || 0);
        if (res.data.status === "completed") {
          setBulkResults(res.data.results);
          const valid = [];
          const invalid = [];
          Object.entries(res.data.results).forEach(([email, result]) => {
            if (
              result.status === "safe" &&
              result.is_valid_syntax &&
              result.is_safe_to_send &&
              !result.is_disposable &&
              result.mx_accepts_mail &&
              !result.has_inbox_full
            ) {
              valid.push(email);
            } else {
              invalid.push(email);
            }
          });
          setVerifiedEmails(valid);
          setInvalidEmails(invalid);
          setValidEmails(valid);
          setIsVerifying(false);
          toast.success("Bulk email verification completed");
        } else {
          setTimeout(() => pollBulkVerification(taskId), 2000);
        }
      } else {
        setIsVerifying(false);
        toast.error("Failed to get verification results");
      }
    } catch (err) {
      setIsVerifying(false);
      toast.error("Error polling verification results");
    }
  };

  const processEmailData = (data) => {
    const validEmailList = [];
    const rowsData = [];
    let emailsToVerify = [];
    if (typeof data[0] === 'string') {
      data.forEach((email, index) => {
        const trimmed = email.trim();
        if (validateEmail(trimmed)) {
          validEmailList.push(trimmed);
          rowsData.push({ id: index, Email: trimmed });
        }
      });
      emailsToVerify = validEmailList;
    }
    else {
      data.forEach((row, index) => {
        const email = row['Email Address'] || row['email'] || row['Email'] || '';
        const trimmed = email.trim();
        if (validateEmail(trimmed)) {
          validEmailList.push(trimmed);
          rowsData.push({ id: index, ...row });
        }
      });
      emailsToVerify = validEmailList;
    }
    setTotalMails(data.length);
    setValidEmails(validEmailList)
    setRows(rowsData);
    setSelectedFileData(rowsData);
    if (rowsData.length > 0) {
      const columnsData = Object.keys(rowsData[0])
        .filter(key => key !== 'id')
        .map((key) => ({
          field: key,
          headerName: key,
          flex: 1,
        }));
      setColumns(columnsData);
    }
    // if (emailsToVerify.length > 0) {
    //   startBulkVerification(emailsToVerify);
    // }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email)?.toLowerCase());
  };

  useEffect(() => {
    if (!detailModalOpen) {
      setSearchTerm("");
    }
  }, [detailModalOpen]);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const storedToken = localStorage.getItem("MailFlow");
        if (!storedToken) {
          console.log("Session expired, Please login again.");
          return;
        }

        const config = {
          headers: {
            Authorization: storedToken,
          },
        };

        console.log("MAILCONTACTS: Fetching groups...");
        const response = await axios.get(`${Key.domain_vmail}/api/v1/user/viewgroups`, config);
        if (response.data) {
          setGroups(response.data.groups);
        }
      } catch (err) {
        console.error("MAILCONTACTS VIEWGROUPS ERROR:", err);
        if (err.response?.status === 401) {
          // Token is invalid or expired
          localStorage.removeItem("MailFlow");
          toast.error("Token expired, please login again.");
        }
      }
    };

    fetchGroups();
  }, [open, deleteOpen]);
  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);

    // Validation logic
    if (value.trim() === "") {
      setNameError(true);
      setNameHelperText("Name is required.");
    } else if (value.length < 3) {
      setNameError(true);
      setNameHelperText("Name must be at least 3 characters long.");
    } else {
      setNameError(false);
      setNameHelperText("");
    }
  };

  const handleSubmit = () => {
    //console.log("handleSubmit called", { name, file, validEmails });
    const token = localStorage.getItem("MailFlow")
    if (!token) {
      toast.error("Session expired, Please login again.");
      return;
    }
    if (name.trim() === "") {
      setNameError(true);
      setNameHelperText("Name is required.");
    }
    if (file === null) {
      setFileError(true);
      setFileHelperText("File is required");
    }
    if (file !== null && name !== "") {
      //console.log("Token being sent:", token);
      const config = {
        headers: {
          Authorization: token,
        },
      };
      setIsLoading(true);
      axios
        .post(
          `${Key.domain_vmail}/api/v1/user/addgroup`,
          {
            name: name,
            emails: validEmails,
          },
          config
        )
        .then((res) => {
          setFile(null);
          setName("");
          setIsLoading(false);
          setOpen(false);
          toast.success("Successfully added group", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          // toast.success("Mail sent", {
          //   position: "bottom-right",
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light",
          // });
        })
        .catch((err) => {
          console.log("API error:", err);
          setIsLoading(false);
          toast.error("Failed to add group");
        });
    }
  };

  // useEffect(() => { }, [columns, rows]);

  const onHandleConfirm = () => {
    const token = localStorage.getItem("MailFlow");
    if (!token) {
      toast.error("Session expired, Please login again.");
      return;
    }

    const config = {
      headers: {
        Authorization: token,
      },
    };

    axios
      .post(`${Key.domain_vmail}/api/v1/user/deletegroup/${groupId}`, {}, config)
      .then((res) => {
        //setModalClose(true);
        setDeleteOpen(false);
        toast.success("Successfully deleted group", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        // setTimeout(() => {
        //   window.location.reload(false);
        // }, 1300);
      })
      .catch((err) => console.log(err));
  };
  const handleDelete = (id) => {
    setDeleteOpen(true);
    setGroupId(id);
  };

  const handleEditClick = (group) => {
    setEditGroupId(group._id);
    setEditName(group.name);
    setEditEmails(group.emails || []);
    setEditSearchTerm("");
    setEmailEditingIndex(null);
    setEmailEditingValue("");
    setNewEmailEntry("");
    setEditOpen(true);
  };

  const handleUpdateSubmit = () => {
    const token = localStorage.getItem("MailFlow");
    if (!token) {
      toast.error("Session expired, Please login again.");
      return;
    }
    if (editName.trim() === "") {
      toast.error("Group name is required.");
      return;
    }

    const config = {
      headers: {
        Authorization: token,
      },
    };

    setIsLoading(true);
    axios
      .post(
        `${Key.domain_vmail}/api/v1/user/updategroup/${editGroupId}`,
        {
          name: editName,
          emails: editEmails,
        },
        config
      )
      .then((res) => {
        setIsLoading(false);
        setEditOpen(false);
        toast.success("Successfully updated group");
        // Update local groups state
        setGroups(groups.map(g => g._id === editGroupId ? { ...g, name: editName, emails: editEmails } : g));
      })
      .catch((err) => {
        console.error("Update API error:", err);
        setIsLoading(false);
        toast.error("Failed to update group");
      });
  };

  const handleRemoveEditEmail = (index) => {
    const updatedEmails = editEmails.filter((_, i) => i !== index);
    setEditEmails(updatedEmails);
  };

  const handleUpdateEditEmail = (index, newValue) => {
    const updatedEmails = editEmails.map((email, i) => i === index ? newValue : email);
    setEditEmails(updatedEmails);
    setEmailEditingIndex(null);
  };

  const handleAddNewEditEmail = () => {
    if (newEmailEntry.trim() === "") return;
    if (!validateEmail(newEmailEntry)) {
      toast.error("Invalid email format");
      return;
    }
    setEditEmails([...editEmails, newEmailEntry.trim()]);
    setNewEmailEntry("");
  };

  const downloadValidEmails = () => {
    if (verifiedEmails.length === 0) return;
    const csvContent = "data:text/csv;charset=utf-8," + verifiedEmails.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `valid_emails_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box sx={{ height: "calc(100vh - 80px)", display: "flex", flexDirection: "column", bgcolor: "#f8fafc", overflow: "hidden" }}>
      <Toolbar
        sx={{
          minHeight: "72px !important",
          zIndex: 1100,
          bgcolor: "#f0f7ff",
          borderBottom: "2px solid #2563eb",
          px: 4,
          boxShadow: "0 1px 3px rgba(37, 99, 235, 0.1)",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 800, color: "#1e3a8a", letterSpacing: "-0.5px" }}
          >
            Contact Groups
          </Typography>
          <Typography variant="caption" sx={{ color: "#1e40af", fontWeight: 600, opacity: 0.8 }}>
            Total groups: {groups?.length || 0}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>

          <Button
            variant="contained"
            disableElevation
            sx={{
              bgcolor: "#2563eb",
              textTransform: "none",
              px: 3,
              py: 1,
              fontWeight: 700,
              borderRadius: "10px",
              "&:hover": { bgcolor: "#1d4ed8" },
            }}
            onClick={() => {
              dispatch(resetCandidatesAction());
              setMailopen(true);
              dispatch(getActiveCandidatesAction(user.id, 1, 100));
            }}
          >
            Hot List Campaigns
          </Button>
          <Button
            variant="outlined"
            sx={{
              textTransform: "none",
              px: 3,
              py: 1,
              fontWeight: 700,
              borderRadius: "10px",
              borderColor: "#bfdbfe",
              color: "#1e40af",
              bgcolor: "#fff",
              mr: 2,
              "&:hover": { borderColor: "#2563eb", bgcolor: "#f0f9ff" },
            }}
            onClick={handleClickOpen}
          >
            New Group
          </Button>

          <Stack direction="row" spacing={0.5} sx={{ bgcolor: "#dbeafe", p: 0.5, borderRadius: "10px" }}>
            <Tooltip title="Grid View">
              <IconButton
                size="small"
                onClick={() => setViewMode("grid")}
                sx={{
                  borderRadius: "8px",
                  bgcolor: viewMode === "grid" ? "#2563eb" : "transparent",
                  color: viewMode === "grid" ? "white" : "#1e40af",
                  "&:hover": { bgcolor: viewMode === "grid" ? "#1d4ed8" : "#eff6ff" },
                }}
              >
                <GridViewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="List View">
              <IconButton
                size="small"
                onClick={() => setViewMode("list")}
                sx={{
                  borderRadius: "8px",
                  bgcolor: viewMode === "list" ? "#2563eb" : "transparent",
                  color: viewMode === "list" ? "white" : "#1e40af",
                  "&:hover": { bgcolor: viewMode === "list" ? "#1d4ed8" : "#eff6ff" },
                }}
              >
                <ViewListIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      </Toolbar>

      <Box sx={{ flex: 1, overflowY: "auto", p: 4 }}>
        {viewMode === "grid" ? (
          <Grid container spacing={2}>
            {groups?.length > 0 &&
              groups.map((group, index) => (
                <Grid item xs={12} sm={6} md={3} lg={2} key={index}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: "12px",
                      border: "1px solid #e5eef9",
                      bgcolor: "#fff",
                      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                      "&:hover": {
                        borderColor: "#3b82f6",
                        bgcolor: "#f8fbff",
                        transform: "translateY(-4px)",
                        boxShadow: "0 12px 16px -4px rgba(37, 99, 235, 0.08), 0 4px 6px -2px rgba(37, 99, 235, 0.03)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                        <Box sx={{ bgcolor: "#eff6ff", p: 0.8, borderRadius: "8px", display: "flex" }}>
                          <EmailIcon sx={{ color: "#2563eb", fontSize: "18px" }} />
                        </Box>
                        <Stack direction="row" spacing={0.5}>
                          <Tooltip title="View Emails">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCardClick(group?._id);
                              }}
                              sx={{ color: "#64748b", "&:hover": { color: "#2563eb", bgcolor: "#eff6ff" } }}
                            >
                              <VisibilityIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Group">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditClick(group);
                              }}
                              sx={{ color: "#64748b", "&:hover": { color: "#2563eb", bgcolor: "#eff6ff" } }}
                            >
                              <EditIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Group">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(group?._id);
                              }}
                              sx={{ color: "#94a3b8", "&:hover": { color: "#ef4444", bgcolor: "#fef2f2" } }}
                            >
                              <DeleteIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 800, color: "#334155", mb: 0.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      >
                        {group.name}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                        <Typography variant="caption" sx={{ color: "#2563eb", fontWeight: 800, bgcolor: "#eff6ff", px: 0.75, py: 0.2, borderRadius: "4px" }}>
                          {group.emails?.length || 0}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                          Contacts
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
          </Grid>
        ) : (
          <Stack spacing={1.5}>
            {groups?.length > 0 &&
              groups.map((group, index) => (
                <Paper
                  elevation={0}
                  key={index}
                  sx={{
                    p: 2,
                    borderRadius: "12px",
                    border: "1px solid #e5eef9",
                    display: "flex",
                    alignItems: "center",
                    transition: "all 0.2s",
                    position: "relative",
                    overflow: "hidden",
                    "&:hover": {
                      borderColor: "#3b82f6",
                      bgcolor: "#f8fbff",
                      "&::before": { width: "4px" }
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: "0px",
                      bgcolor: "#2563eb",
                      transition: "width 0.2s"
                    }
                  }}
                >
                  <Box sx={{ bgcolor: "#eff6ff", p: 1, borderRadius: "8px", mr: 2.5, display: "flex" }}>
                    <EmailIcon sx={{ color: "#2563eb", fontSize: "20px" }} />
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#1e293b", lineHeight: 1.2 }}>
                      {group.name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#94a3b8", fontWeight: 600 }}>
                      Created {moment(group.createdAt).fromNow()}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={{ textAlign: "center", minWidth: "80px", mr: 2 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 900, color: "#2563eb", lineHeight: 1 }}>
                        {group.emails?.length || 0}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 700, fontSize: "0.65rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                        Contacts
                      </Typography>
                    </Box>
                    <Stack direction="row" spacing={1}>
                      <Tooltip title="View Emails">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCardClick(group?._id);
                          }}
                          sx={{ color: "#64748b", "&:hover": { color: "#2563eb", bgcolor: "#eff6ff" } }}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Edit Group">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(group);
                          }}
                          sx={{ color: "#64748b", "&:hover": { color: "#2563eb", bgcolor: "#eff6ff" } }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete Group">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(group?._id);
                          }}
                          sx={{ color: "#cbd5e1", "&:hover": { color: "#ef4444", bgcolor: "#fef2f2" } }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Box>
                </Paper>
              ))}
          </Stack>
        )}
        <Dialog
          open={detailModalOpen}
          onClose={() => setDetailModalOpen(false)}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: { borderRadius: "16px", overflow: "hidden", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }
          }}
        >
          <DialogTitle sx={{
            bgcolor: "#f8fafc",
            p: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: "1px solid #e2e8f0"
          }}>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 800, color: "#1e3a8a", fontSize: "1.1rem" }}>
                {selectedGroup?.name || "Group Details"}
              </Typography>
              <Typography variant="caption" sx={{ color: "#3b82f6", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                {selectedFileEmails?.length || 0} Contacts Total
              </Typography>
            </Box>
            <IconButton onClick={() => setDetailModalOpen(false)} size="small" sx={{ color: "#94a3b8", "&:hover": { color: "#1e3a8a", bgcolor: "#f1f5f9" } }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 0, bgcolor: "#fff", display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ p: 2, borderBottom: "1px solid #f1f5f9", bgcolor: "#f8fafc" }}>
              <Paper
                elevation={0}
                sx={{
                  p: '2px 4px',
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "10px",
                  "&:focus-within": { borderColor: "#3b82f6", boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)" }
                }}
              >
                <IconButton sx={{ p: '10px', color: "#94a3b8" }} aria-label="search">
                  <SearchIcon />
                </IconButton>
                <InputBase
                  sx={{ ml: 1, flex: 1, fontWeight: 500, color: "#1e293b" }}
                  placeholder="Search contacts by email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Paper>
            </Box>

            <Box sx={{ flexGrow: 1, overflowY: "auto", maxHeight: "400px" }}>
              {selectedGroup && (
                <List sx={{ p: 0 }}>
                  {selectedFileEmails
                    .filter(row => {
                      const emailVal = Object.values(row).join(" ").toLowerCase();
                      return emailVal.includes(searchTerm.toLowerCase());
                    })
                    .map((row, index) => {
                      // Find the email field (dynamic)
                      const emailField = Object.entries(row).find(([k, v]) => k.toLowerCase().includes('email'))?.[1] || Object.values(row)[0];
                      const initials = String(emailField).charAt(0).toUpperCase();

                      return (
                        <ListItem
                          key={index}
                          divider
                          sx={{
                            px: 3,
                            py: 1.5,
                            transition: "all 0.2s",
                            "&:hover": { bgcolor: "#f8fbff" },
                            borderBottom: "1px solid #f1f5f9"
                          }}
                        >
                          <ListItemAvatar>
                            <Avatar sx={{ bgcolor: stringToColor(String(emailField)), fontWeight: 800, fontSize: "0.9rem" }}>
                              {initials}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography variant="body2" sx={{ fontWeight: 700, color: "#1e293b" }}>
                                {emailField}
                              </Typography>
                            }
                            secondary={
                              <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                                {Object.entries(row).map(([k, v]) => {
                                  if (k === 'id' || v === emailField) return null;
                                  return (
                                    <Typography key={k} variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                                      {k}: {v}
                                    </Typography>
                                  );
                                })}
                              </Stack>
                            }
                          />
                        </ListItem>
                      );
                    })}
                  {selectedFileEmails.length === 0 && (
                    <Box sx={{ p: 4, textAlign: 'center' }}>
                      <PersonIcon sx={{ color: "#cbd5e1", fontSize: 48, mb: 1 }} />
                      <Typography sx={{ color: "#64748b", fontWeight: 600 }}>No contacts found in this group</Typography>
                    </Box>
                  )}
                </List>
              )}
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 2, bgcolor: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>
            <Button
              onClick={() => setDetailModalOpen(false)}
              fullWidth
              variant="contained"
              disableElevation
              sx={{
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 700,
                bgcolor: "#1e3a8a",
                py: 1,
                "&:hover": { bgcolor: "#1e293b" }
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setFileHelperText("")
          setFile(null)
          setName("");
        }}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Slide
          direction="left"
          in={open}
          mountOnEnter
          unmountOnExit
          timeout={{ enter: 1000, exit: 1000 }}
          style={{
            transitionTimingFunction: "cubic-bezier(0.68, -0.55, 0.27, 1.55)",
          }}
        >
          <Paper
            elevation={4}
            sx={{
              ...modalStyles,
              maxWidth: "600px",
              bgcolor: "white",
              transition: "transform 0.5s ease-in-out",
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '90vh'
            }}
          >
            <Box
              sx={{
                px: 4,
                py: 2.5,
                borderBottom: "1px solid #f1f5f9",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                bgcolor: "#fff",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 800, color: "#1e293b" }}>
                Create New Group
              </Typography>
              <IconButton onClick={handleClose} size="small">
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <Box sx={{ p: 4, flexGrow: 1, overflowY: "auto" }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#475569", mb: 1, display: "block" }}>
                IDENTIFICATION
              </Typography>
              <TextField
                fullWidth
                placeholder="e.g. Sales Leads Q2"
                variant="outlined"
                value={name}
                onChange={handleNameChange}
                error={nameError}
                helperText={nameHelperText}
                sx={{
                  mb: 4,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    bgcolor: "#fff",
                  },
                }}
              />

              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#475569", mb: 1, display: "block" }}>
                DATA IMPORT (CSV)
              </Typography>
              <Box
                sx={{
                  border: "2px dashed #e2e8f0",
                  borderRadius: "12px",
                  p: 4,
                  textAlign: "center",
                  bgcolor: "#f8fafc",
                  mb: 2,
                  cursor: "pointer",
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: "all 0.2s",
                  "&:hover": { borderColor: "#2563eb", bgcolor: "#f0f7ff" },
                }}
                component="label"
              >
                <input type="file" hidden accept=".csv" onChange={handleFileUpload} />
                <DownloadIcon sx={{ color: "#3b82f6", mb: 1.5, fontSize: "40px" }} />
                <Typography variant="body1" sx={{ fontWeight: 700, color: "#1e293b", display: "block", mb: 0.5 }}>
                  {file ? file.name : "Click to select CSV file"}
                </Typography>
                <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                  Standard CSV format with Email columns
                </Typography>
              </Box>

              {fileError && (
                <Typography color="error" variant="caption" sx={{ mt: 1, display: "block", fontWeight: 700 }}>
                  {fileHelperText}
                </Typography>
              )}

              {isVerifying ? (
                <Box sx={{ mt: 4 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Typography variant="caption" sx={{ fontWeight: 800, color: "#4f46e5" }}>
                      Verifying Emails...
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: 800, color: "#4f46e5" }}>
                      {verificationProgress}%
                    </Typography>
                  </Box>
                  <Box sx={{ height: 8, bgcolor: "#e2e8f0", borderRadius: 4, overflow: "hidden" }}>
                    <Box
                      sx={{
                        height: "100%",
                        width: `${verificationProgress}%`,
                        bgcolor: "#4f46e5",
                        transition: "width 0.3s ease",
                      }}
                    />
                  </Box>
                </Box>
              ) : bulkStatus === "completed" ? (
                <Box
                  sx={{
                    mt: 4,
                    p: 2,
                    bgcolor: "#ecfdf5",
                    border: "1px solid #10b981",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#065f46" }}>
                      {verifiedEmails.length} Verified Contacts
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#059669" }}>
                      Validation complete and ready for broadcast
                    </Typography>
                  </Box>
                  <Button
                    size="small"
                    variant="contained"
                    disableElevation
                    onClick={downloadValidEmails}
                    sx={{ bgcolor: "#10b981", "&:hover": { bgcolor: "#059669" }, textTransform: "none", borderRadius: "6px" }}
                  >
                    Export
                  </Button>
                </Box>
              ) : null}

              {rows.length > 0 && !isVerifying && (
                <Box sx={{ mt: 4, borderRadius: "10px", overflow: "hidden", border: "1px solid #e2e8f0" }}>
                  <DataGrid
                    columns={columns}
                    rows={rows}
                    autoHeight
                    hideFooter
                    density="compact"
                    sx={{ border: "none" }}
                  />
                </Box>
              )}
            </Box>

            <Divider />
            <Box sx={{ p: 3, display: "flex", gap: 2, justifyContent: "flex-end", bgcolor: "#f8fafc" }}>
              <Button onClick={handleClose} sx={{ color: "#64748b", textTransform: "none", fontWeight: 700 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                disableElevation
                onClick={handleSubmit}
                disabled={file === null || name === "" || isLoading || isVerifying || (bulkStatus === "completed" && verifiedEmails.length === 0)}
                sx={{ bgcolor: "#1e293b", "&:hover": { bgcolor: "#0f172a" }, textTransform: "none", px: 4, borderRadius: "8px", fontWeight: 700 }}
              >
                {isLoading ? <CircularProgress size={20} color="inherit" /> : "Save Group"}
              </Button>
            </Box>
          </Paper>
        </Slide>
      </Modal>
      <Dialog
        open={editOpen}
        onClose={() => setEditOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: "16px", overflow: "hidden" }
        }}
      >
        <DialogTitle sx={{ bgcolor: "#f8fafc", p: 2.5, borderBottom: "1px solid #e2e8f0" }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" sx={{ fontWeight: 800, color: "#1e3a8a" }}>
              Edit Group
            </Typography>
            <IconButton onClick={() => setEditOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ mb: 3, mt: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#475569", mb: 1 }}>
              GROUP NAME
            </Typography>
            <TextField
              fullWidth
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
              placeholder="Enter group name"
              variant="outlined"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
            />
          </Box>

          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#475569", mb: 1 }}>
            MANAGE EMAILS ({editSearchTerm ? `${editEmails.filter(e => e.toLowerCase().includes(editSearchTerm.toLowerCase())).length} of ${editEmails.length}` : editEmails.length})
          </Typography>

          <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Add new email..."
                value={newEmailEntry}
                onChange={(e) => setNewEmailEntry(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddNewEditEmail()}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
              />
              <Button
                variant="contained"
                disableElevation
                onClick={handleAddNewEditEmail}
                sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 700, bgcolor: "#2563eb" }}
              >
                Add
              </Button>
            </Box>

            <Paper
              elevation={0}
              sx={{
                p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                bgcolor: "#f1f5f9",
                border: "1px solid #e2e8f0",
                borderRadius: "10px",
              }}
            >
              <IconButton sx={{ p: '8px', color: "#94a3b8" }} size="small">
                <SearchIcon fontSize="small" />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, fontSize: "0.875rem", fontWeight: 500 }}
                placeholder="Search emails in this group..."
                value={editSearchTerm}
                onChange={(e) => setEditSearchTerm(e.target.value)}
              />
              {editSearchTerm && (
                <IconButton sx={{ p: '8px' }} size="small" onClick={() => setEditSearchTerm("")}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </Paper>
          </Box>

          <Paper variant="outlined" sx={{ borderRadius: "12px", maxHeight: "300px", overflow: "auto" }}>
            <List sx={{ p: 0 }}>
              {editEmails
                .filter(email => email.toLowerCase().includes(editSearchTerm.toLowerCase()))
                .map((email, index) => {
                  // Important: use the actual index in editEmails for updates/removals
                  const actualIndex = editEmails.findIndex(e => e === email);
                  return (
                    <ListItem
                      key={index}
                      divider={index < editEmails.length - 1}
                      sx={{ px: 2, py: 1 }}
                    >
                      {emailEditingIndex === actualIndex ? (
                        <TextField
                          fullWidth
                          autoFocus
                          size="small"
                          value={emailEditingValue}
                          onChange={(e) => setEmailEditingValue(e.target.value)}
                          onBlur={() => handleUpdateEditEmail(actualIndex, emailEditingValue)}
                          onKeyPress={(e) => e.key === 'Enter' && handleUpdateEditEmail(actualIndex, emailEditingValue)}
                        />
                      ) : (
                        <>
                          <ListItemAvatar sx={{ minWidth: 45 }}>
                            <Avatar sx={{ width: 32, height: 32, bgcolor: stringToColor(email), fontSize: "0.8rem" }}>
                              {email.charAt(0).toUpperCase()}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={<Typography variant="body2" sx={{ fontWeight: 600 }}>{email}</Typography>}
                          />
                          <Stack direction="row" spacing={0.5}>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setEmailEditingIndex(actualIndex);
                                setEmailEditingValue(email);
                              }}
                              sx={{ color: "#64748b", "&:hover": { color: "#2563eb" } }}
                            >
                              <EditIcon sx={{ fontSize: "18px" }} />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleRemoveEditEmail(actualIndex)}
                              sx={{ color: "#94a3b8", "&:hover": { color: "#ef4444" } }}
                            >
                              <DeleteIcon sx={{ fontSize: "18px" }} />
                            </IconButton>
                          </Stack>
                        </>
                      )}
                    </ListItem>
                  );
                })}
              {editEmails.filter(email => email.toLowerCase().includes(editSearchTerm.toLowerCase())).length === 0 && (
                <Box sx={{ p: 3, textAlign: 'center', color: "#94a3b8" }}>
                  {editSearchTerm ? "No matching emails found" : "No emails in this group"}
                </Box>
              )}
            </List>
          </Paper>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, bgcolor: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>
          <Button onClick={() => setEditOpen(false)} sx={{ fontWeight: 700, textTransform: "none", color: "#64748b" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            onClick={handleUpdateSubmit}
            disabled={isLoading || editName.trim() === ""}
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 700,
              px: 4,
              bgcolor: "#1e3a8a",
              "&:hover": { bgcolor: "#1e293b" }
            }}
          >
            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Delete Group"}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this group?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setDeleteOpen(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onHandleConfirm}
            color="error"
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Modal
        open={mailOpen}
        onClose={() => {
          setMailopen(false);
        }}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Slide
          direction="left"
          in={mailOpen}
          //container={addCandidateRef.current}
          mountOnEnter
          unmountOnExit
          timeout={{ enter: 1000, exit: 1000 }}
          style={{
            transitionTimingFunction: "cubic-bezier(0.68, -0.55, 0.27, 1.55)",
          }}
        >
          <Paper
            elevation={4}
            sx={{
              ...modalStyles,
              transition: "transform 0.5s ease-in-out",
              overflow: "hidden",
              overflowY: "hidden",
              display: "flex",
              flexDirection: "column",
              height: "85vh",
              maxHeight: "85vh",
            }}
          >
            <Mailer setMailopen={setMailopen} />
          </Paper>
        </Slide>
      </Modal>
    </Box>
  );
}

export default Groups;
